import React, { Component } from "react";
import Alert from "react-s-alert";
import Notification from "react-web-notification";
import SocketContext from "./function/SocketContext";
import { ORDER_TYPE_NAME, ORDER_ICONS } from "./enums/OrderEnums";
import { connect } from "react-redux";

export class NotificationClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ignore: true,
      title: "",
    };
  }

  componentDidMount() {
    this.props.socket.service("ticket").on("created", (data) => {
      let notifData = {
        title: "Ticket has been Raised",
        body: `A new ticket #${data.ticket_number} has been raised by user.`,
      };
      this.handleNotification(notifData);
    });
    if (this.props?.auth?.user?.VendorUser?.role !== "superadmin") {
      this.props.socket
        .service("ordering")
        .on("pending_notification", (data) => {
          let notifData = {
            title: `New ${ORDER_TYPE_NAME[data?.order_type]} Order`,
            body: `A New ${ORDER_TYPE_NAME[data?.order_type]} Order #${
              data?.order_id
            } has been placed by ${data?.user_details?.first_name}`,
          };
          this.handleNotification(notifData);
        });
    }
  }

  handlePermissionGranted() {
    this.setState({
      ignore: false,
    });
  }
  handlePermissionDenied() {
    this.setState({
      ignore: true,
    });
  }
  handleNotSupported() {
    this.setState({
      ignore: true,
    });
  }

  handleNotificationOnClick(e, tag) {
    console.log(e, "Notification clicked tag:" + tag);
  }

  handleNotificationOnError(e, tag) {
    console.log(e, "Notification error tag:" + tag);
  }

  handleNotificationOnClose(e, tag) {
    console.log(e, "Notification closed tag:" + tag);
  }

  handleNotificationOnShow(e, tag) {
    this.playSound();
    console.log(e, "Notification shown tag:" + tag);
  }

  playSound(filename) {
    document.getElementById("sound").play();
  }

  handleNotification(data) {
    if (this.state.ignore) {
      return;
    }
    const now = Date.now();
    const title = data?.title;
    const body = data?.body;
    const tag = now;
    const icon = "https://iconslist.s3.amazonaws.com/amealiologo.png";
    const options = {
      tag: tag,
      body: body,
      icon: icon,
      lang: "en",
      dir: "ltr",
      sound: "./assets/sound/notificationSound.mp3", // no browsers supported https://developer.mozilla.org/en/docs/Web/API/notification/sound#Browser_compatibility
    };
    this.setState({
      title: title,
      options: options,
    });
  }

  render() {
    return (
      <>
        <Notification
          ignore={this.state.ignore && this.state.title !== ""}
          notSupported={this.handleNotSupported.bind(this)}
          onPermissionGranted={this.handlePermissionGranted.bind(this)}
          onPermissionDenied={this.handlePermissionDenied.bind(this)}
          onShow={this.handleNotificationOnShow.bind(this)}
          onClick={this.handleNotificationOnClick.bind(this)}
          onClose={this.handleNotificationOnClose.bind(this)}
          onError={this.handleNotificationOnError.bind(this)}
          timeout={10000}
          title={this.state.title}
          options={this.state.options}
        />
        <audio id="sound" preload="auto">
          <source
            src="./assets/sound/notificationSound.mp3"
            type="audio/mpeg"
          />
          <embed
            hidden={true}
            autostart="false"
            loop={false}
            src="./assets/sound/notificationSound.mp3"
          />
        </audio>
      </>
    );
  }
}

const BrowserNotification = (props) => (
  <SocketContext.Consumer>
    {(socket) => <NotificationClass {...props} socket={socket} />}
  </SocketContext.Consumer>
);

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(BrowserNotification);
